export default [
  {
    path: "/contrapartidas",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "contrapartidas_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Contrapartidas", to: "contrapartidas_list" }],
          permission: "contrapartida:view",
          title: "Contrapartidas"
        }
      },
      {
        name: "contrapartidas_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "Contrapartidas", to: "contrapartidas_list" }],
          permission: "contrapartida:create",
          title: "Contrapartidas - Cadastro"
        }
      },
      {
        name: "contrapartidas_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "Contrapartidas", to: "contrapartidas_list" }],
          permission: "contrapartida:edit",
          title: "Contrapartidas - Edição"
        }
      }
    ]
  }
];
